import { Module } from 'vuex'

import { RootState } from '../types'

import { CartState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

const namespaced = true

export const cart: Module<CartState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
